
//   document.addEventListener('DOMContentLoaded', function () {
//     const giftCheckbox = document.getElementById('gift-checkbox');
//     const giftEmailWrapper = document.getElementById('gift-email-wrapper');
//     const giftEmailInput = document.getElementById('gift-email');
//     const orderNoteInput = document.getElementById('order-note');

//     if (!giftCheckbox) return;

//     giftCheckbox.addEventListener('change', function () {
//       giftEmailWrapper.style.display = this.checked ? 'block' : 'none';

//       if (!this.checked) {
//         giftEmailInput.value = '';
//         updateOrderNote('');
//       }
//     });

//     giftEmailInput.addEventListener('input', function () {
//       updateOrderNote(this.value);
//     });

//     function updateOrderNote(email) {
//       if (email) {
//         orderNoteInput.value = 'Gift recipient email: ' + email;
//       } else {
//         orderNoteInput.value = '';
//       }
//     }
//   });


// document.addEventListener('DOMContentLoaded', function () {
//   const cartNoteTextarea = document.getElementById('Cart-note');
//   const orderNoteInput = document.getElementById('order-note');

//   const giftCheckbox = document.getElementById('gift-checkbox');
//   const giftEmailWrapper = document.getElementById('gift-email-wrapper');
//   const giftEmailInput = document.getElementById('gift-email');
//   const giftError = document.getElementById('gift-email-error');

//   if (!cartNoteTextarea || !orderNoteInput) return;

//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   const giftLabel = 'Gift recipient email:';

//   function buildOrderNote(validatedEmail) {
//     const customerNote = cartNoteTextarea.value.trim();
//     let orderNote = '';

//     // Gift email FIRST (only if valid)
//     if (validatedEmail) {
//       orderNote = giftLabel + ' ' + validatedEmail;
//       if (customerNote) {
//         orderNote += '\n \n'; // visible space line
//       }
//     }

//     // Customer note SECOND
//     if (customerNote) {
//       orderNote += customerNote;
//     }

//     console.log('FINAL order-note:', JSON.stringify(orderNote));
//     orderNoteInput.value = orderNote;
//   }

//   // Initial sync (no email yet)
//   buildOrderNote('');

//   // Cart note typing
//   cartNoteTextarea.addEventListener('input', function () {
//     const email = emailRegex.test(giftEmailInput.value.trim())
//       ? giftEmailInput.value.trim()
//       : '';
//     buildOrderNote(email);
//   });

//   // Gift checkbox toggle
//   if (giftCheckbox) {
//     giftCheckbox.addEventListener('change', function () {
//       giftEmailWrapper.style.display = this.checked ? 'block' : 'none';

//       if (!this.checked) {
//         giftEmailInput.value = '';
//         giftError.style.display = 'none';
//         buildOrderNote('');
//       }
//     });
//   }

//   // ✅ Email validation ONLY on change
//   if (giftEmailInput) {
//     giftEmailInput.addEventListener('change', function () {
//       const email = this.value.trim();

//       if (!email || !emailRegex.test(email)) {
//         giftError.style.display = email ? 'block' : 'none';
//         buildOrderNote('');
//         return;
//       }

//       giftError.style.display = 'none';
//       buildOrderNote(email);
//     });
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const cartNoteTextarea = document.getElementById('Cart-note');
  const orderNoteInput = document.getElementById('order-note');

  if (!cartNoteTextarea || !orderNoteInput) return;

  const giftCheckbox = document.getElementById('gift-checkbox');
  const giftEmailWrapper = document.getElementById('gift-email-wrapper');
  const giftEmailInput = document.getElementById('gift-email');
  const giftError = document.getElementById('gift-email-error');

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const giftLabel = 'Gift recipient email:';

  function getValidGiftEmail() {
    if (!giftEmailInput) return '';
    const email = giftEmailInput.value.trim();
    return emailRegex.test(email) ? email : '';
  }

  function buildOrderNote(validatedEmail) {
    const customerNote = cartNoteTextarea.value.trim();
    let orderNote = '';

    if (validatedEmail) {
      orderNote = giftLabel + ' ' + validatedEmail;
      if (customerNote) {
        orderNote += '\n \n';
      }
    }

    if (customerNote) {
      orderNote += customerNote;
    }

    orderNoteInput.value = orderNote;
  }

  // Initial sync
  buildOrderNote(getValidGiftEmail());

  // Cart note typing
  cartNoteTextarea.addEventListener('input', function () {
    buildOrderNote(getValidGiftEmail());
  });

  // Gift checkbox toggle (only if exists)
  if (giftCheckbox && giftEmailWrapper && giftEmailInput) {
    giftCheckbox.addEventListener('change', function () {
      giftEmailWrapper.style.display = this.checked ? 'block' : 'none';

      if (!this.checked) {
        giftEmailInput.value = '';
        if (giftError) giftError.style.display = 'none';
        buildOrderNote('');
      }
    });
  }

  // Email validation (only if field exists)
  if (giftEmailInput) {
    giftEmailInput.addEventListener('change', function () {
      const email = this.value.trim();

      if (!email || !emailRegex.test(email)) {
        if (giftError) giftError.style.display = email ? 'block' : 'none';
        buildOrderNote('');
        return;
      }

      if (giftError) giftError.style.display = 'none';
      buildOrderNote(email);
    });
  }
});













